import React from 'react'
import { Helmet } from 'react-helmet-async'
import MemberServicesHero from '../components/sections/MemberServicesHero'
import {
  IntroductionSection,
  MemberServicesSection,
  MasterpieceSection
} from '../components/global'

const MemberServicesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Member Services - Exclusive Luxury Privileges</title>
        <meta name="description" content="Discover the exclusive privileges and personalized services available to FGA Prestige members. From personal styling to VIP events, experience luxury redefined." />
        <meta property="og:title" content="Member Services - FGA Prestige" />
        <meta property="og:description" content="Discover the exclusive privileges and personalized services available to FGA Prestige members." />
        <meta property="og:url" content="https://fgaprestige.com/member-services" />
        <meta property="og:image" content="/og-member-services.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Member Services" />
      </Helmet>
      
      <main className="min-h-screen">
        {/* Hero Section - customized for Member Services */}
        <MemberServicesHero />
        
        {/* Introduction Section - exact same component as landing page */}
        <IntroductionSection />
        
        {/* Member Services Section - exact same component as landing page */}
        <MemberServicesSection />
        
        {/* Your Life, Our Masterpiece - customized for Member Services */}
        <MasterpieceSection backgroundImage="Member Services/Your Life Our Masterpiece.png" />
      </main>
    </>
  )
}

export default MemberServicesPage